import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useNotificationStore = defineStore('notificationtStore', () => {

    const alerts = ref([])
    const messages = ref([])

    const nbrOfAlerts = computed(() => alerts.value.length)
    const nbrOfMessages = computed(() => messages.value.length)

    function addAlert(alert) {

        if (alert instanceof Array) {
            alerts.value.concat(alert)
        } else {
            alerts.value.push(alert)
        }
    }

    function addMessage(message) {
        if (message instanceof Array) {
            messages.value.concat(message)
        } else {
            messages.value.push(message)
        }
    }

    function clearMessages() {
        messages.value = []
    }

    function clearAlerts() {
        alerts.value = []
    }

    return {
        alerts,
        messages,
        nbrOfAlerts,
        nbrOfMessages,
        addAlert,
        addMessage,
        clearMessages,
        clearAlerts
    }

}) 